import { getField, updateField } from "vuex-map-fields";
import db from "@/firebase/firebaseInit";

const state = {
    allReports: [],
};

const actions = {
    async fetchAllReports({ commit }) {

        // order by date

        



         db.collection("reports")
            .orderBy("date", "desc")
            .get()
            .then(
            (snapshot) => {
                var allReports = [];
                snapshot.forEach(doc => {
                    allReports.push(doc.data())
                    // allReports.push({
                    //     id: doc.id,
                    //     content: doc.data()
                    // });
                });
                commit("updateField", {
                    path: "allReports",
                    value: allReports,
                })
            });
    },
};

const mutations = {
    updateField,
};

const getters = {
    getField,
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
};
